var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49577 9C7.64257 9 7.77809 8.97348 7.90232 8.92043C8.02654 8.86149 8.14512 8.77308 8.25805 8.65521L14.712 1.76817C14.904 1.56778 15 1.32613 15 1.04322C15 0.848723 14.9548 0.674852 14.8645 0.521611C14.7798 0.362475 14.6612 0.235756 14.5088 0.141453C14.3619 0.047151 14.1982 -5.86244e-07 14.0175 -5.78784e-07C13.7465 -5.67593e-07 13.5065 0.109037 13.2976 0.327112L7.49577 6.5334L1.69396 0.327112C1.48504 0.109037 1.24788 -5.15251e-08 0.982495 -4.05673e-08C0.79616 -3.28735e-08 0.629587 0.0471515 0.482778 0.141454C0.335968 0.235757 0.220214 0.362475 0.135516 0.521611C0.0451718 0.674852 -3.75005e-07 0.848723 -3.66057e-07 1.04322C-3.53041e-07 1.32613 0.0931674 1.56778 0.279503 1.76817L6.73348 8.65521C6.84641 8.77308 6.96499 8.86149 7.08922 8.92043C7.21344 8.97348 7.34896 9 7.49577 9Z",
    fill: "#00726B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.56ab60082c1066742bdcf50419c6618e.svg";
export { ForwardRef as ReactComponent };